<template lang="html">
    <autonome-home></autonome-home>
</template>

<script>
import AutonomeHome from './AutonomeHome.vue';

export default {
    name: 'Home',
    components: {
        AutonomeHome,
    },
};
</script>



// WEBPACK FOOTER //
// src/components/page/Home/Home.vue